module.exports = __webpack_public_path__ + "img/tea.be5030ca.webp";